import React, { useContext, useEffect, useState } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { MainWrap } from '../../utilities/Shared';
import Select from 'react-select';
import axios from 'axios';
import { PLSSalesReps, PLSCSRReps } from '../../utilities/Reps';

const EstimatingQuote = () => {
  const [error, setError] = useState(null);
  const [customerList, setCustomerList] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedSalesRep, setSelectedSalesRep] = useState(null);
  const [salesRepsList, setSalesRepsList] = useState(null);
  const [selectedCSR, setSelectedCSR] = useState(null);
  const [csrList, setCSRList] = useState(null);
  
  const [selectedContact, setSelectedContact] = useState(null);
  const [contactList, setContactList] = useState([]); // ← start with empty array

  // Fetch global lists once on mount
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        // Customers
        const custRes = await axios.get('http://localhost:5001/customers/all');
        const formattedCustomers = custRes.data.map(customer => ({
          value: customer._id || customer.id,
          label: customer.name || customer.customerName,
          customer,
        }));
        setCustomerList(formattedCustomers);

        // Sales Reps (global list)
        const reps = await PLSSalesReps();
        const formattedSales = reps.map(rep => ({
          value: rep._id || rep.id,
          label: `${rep.firstName} ${rep.lastName?.[0] || ''}`,
          rep,
        }));
        setSalesRepsList(formattedSales);

        // CSRs (global list)
        const csrreps = await PLSCSRReps();
        const formattedCSR = csrreps.map(rep => ({
          value: rep._id || rep.id,
          label: rep.firstName,
          rep,
        }));
        setCSRList(formattedCSR);
      } catch (err) {
        console.error('Error fetching initial data:', err);
        setError('Failed to load initial data');
      }
    };

    fetchInitialData();
  }, []);

  // When customer changes → update contacts + defaults
  const handleCustomerChange = (option) => {
    if (!option) {
      // Clear everything
      setSelectedCustomer(null);
      setContactList([]);
      setSelectedContact(null);
      setSelectedSalesRep(null);
      setSelectedCSR(null);
      return;
    }

    const customer = option.customer;
    setSelectedCustomer(customer);

    // 1. Contacts
    if (customer.contacts?.length > 0) {
      const formattedContacts = customer.contacts.map(contact => ({
        value: contact._id || contact.id || contact.contactid,
        label: contact.name || `${contact.firstName || ''} ${contact.lastName || ''}`.trim(),
        contact,
      }));

      setContactList(formattedContacts);
      
      // Auto-select first contact (like many systems do)
      setSelectedContact(formattedContacts[0].contact);
    } else {
      setContactList([]);
      setSelectedContact(null);
    }

    // 2. Default Sales Rep from customer
    if (customer.salesrep) {
      setSelectedSalesRep(customer.salesrep);
    } else {
      setSelectedSalesRep(null);
    }

    // 3. Default CSR from customer
    if (customer.custrep) {
      setSelectedCSR(customer.custrep);
    } else {
      setSelectedCSR(null);
    }
  };

  return (
    <MainWrap className="min-h-screen bg-gray-50 p-6">
      {/* Header */}
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900">
          Quote <span className="text-2xl ml-12">01-05-2026</span>
        </h1>
        <hr className="border-gray-700 mt-4" />
      </div>

      {/* Top Section */}
      <div className="bg-white rounded-lg shadow p-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <div>
            <label className="block font-bold text-gray-700 mb-1">Customer</label>
            <Select
              options={customerList}
              value={customerList?.find(opt => opt.value === selectedCustomer?._id) ?? null}
              onChange={handleCustomerChange}
              placeholder="Search customer..."
              isClearable
              isSearchable
            />
          </div>

          <div>
            <label className="block font-bold text-gray-700 mb-1">Contact</label>
            <Select
              options={contactList}
              value={
                contactList?.find(
                  opt => opt.value === selectedContact?._id || opt.value === selectedContact?.contactid
                ) ?? null
              }
              onChange={(opt) => setSelectedContact(opt ? opt.contact : null)}
              placeholder="Select contact..."
              isClearable
              isDisabled={!selectedCustomer} // ← nice UX improvement
            />
          </div>
 <div>
            <label className="block font-bold text-gray-700 mb-1">Sales Rep</label>
            <Select
              options={salesRepsList}
              value={salesRepsList?.find(opt => opt.value === selectedSalesRep?._id) ?? null}
              onChange={opt => setSelectedSalesRep(opt?.rep ?? null)}
              placeholder="Sales Rep"
              isClearable
            />
          </div>

          <div>
            <label className="block font-bold text-gray-700 mb-1">CSR</label>
            <Select
              options={csrList}
              value={csrList?.find(opt => opt.value === selectedCSR?._id) ?? null}
              onChange={opt => setSelectedCSR(opt?.rep ?? null)}
              placeholder="CSR"
              isClearable
            />
          </div>
         
        </div>

        <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mt-6">
         
 <div>
            <label className="block font-bold text-gray-700 mb-1">Project</label>
            <input type="text" className="w-full border border-green-600 rounded px-2 py-1" />
          </div>

          <div>
            <label className="block font-bold text-gray-700 mb-1">Project Style</label>
            <select className="w-full border border-green-600 rounded px-2 py-1">
              <option>Select Product Style</option>
              <option>Brochures</option>
              <option>Postcards</option>
              <option>Stitched Books</option>
            </select>
          </div>
          <div>
            <label className="block font-bold text-gray-700 mb-1">Job Due Date</label>
            <input type="text" className="w-full border border-green-600 rounded px-2 py-1" />
          </div>

          <div>
            <label className="block font-bold text-gray-700 mb-1">Prev Job #</label>
            <input type="text" className="w-full border border-green-600 rounded px-2 py-1" />
          </div>

          <div>
            <label className="block font-bold text-gray-700 mb-1">Prev Quote #</label>
            <input type="text" className="w-full border border-green-600 rounded px-2 py-1" />
          </div>
        </div>
      </div>

      {/* ... rest of your quote form ... */}
    </MainWrap>
  );
};

export default EstimatingQuote;